export default __webpack_public_path__ + "static/media/fnl_new_home_banner.eefa2c65.jpg";